









import {Component} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"
import {GetDlyChargeStatistics, GetVaComplStatistics} from "@/api/report"

@Component
export default class chargeStatistics extends AbpBase{
	loading = false
	dateRange:any = []
	query:any = {
		MachineCode: '',
		MachineXlh: ''
	}
	data:any = []
	selects:Array<any> = []
	materialTypeItem:any = []
	columns:any = [
		{
			title: '机器号',
			key: 'machinecode'
		},
		{
			title: '序列号',
			key: 'machineXlh'
		},
		{
			title: '检测日期',
			key: 'detectionDate'
		},
		{
			title: '进水口',
			align: 'center',
			children:[
				{
					title: '进水口细菌 cfu/ml',
					key: 'jskXj'
				},
				{
					title: '进水口内毒素 Eu/ml',
					key: 'jskNds'
				}
			]
		},
		{
			title: '出水口',
			align: 'center',
			children:[
				{
					title: '出水口细菌 cfu/ml',
					key: 'cskXj'
				}
			]
		},
		{
			title: '采样人',
			key: 'createUser'
		}
	]
	async created(){
		this.dateRange = this.getMonthStartAndEnd()
		this.getData()
	}
	deteChange(e:any){
		this.dateRange = e
		this.getData()
	}
	options = {
		shortcuts: [
			{
				text: '一个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
					return [start, end];
				}
			},
			{
				text: '三个月',
				value() {
					const end = new Date();
					const start = new Date();
					end.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
					return [start, end];
				}
			}
		]
	}
	private async getData() {
		this.loading = true
		let res = await GetVaComplStatistics({
			MachineCode: this.query.MachineCode,
			MachineXlh: this.query.MachineXlh,
			StartDate: this.dateRange[0],
			EndDate: this.dateRange[1]
		})
		this.data = res.objects
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/bacterial/index.vue